import { gql } from "@apollo/client";

export const DELETE_DRIVER_DOCUMENT = gql`
  mutation deleteDriverDocument($driverProfileId: String!, $documentKey: String!){
    deleteDriverDocument(driverProfileId: $driverProfileId, documentKey: $documentKey){
      success
      message
    }
  }
` 